import classNames from "classnames";
import * as React from "react";
import { messagesAuditEvents } from "~/AIEvents/messagesAuditEvents";
import { useTrackEvent } from "~/common/audit";
import { AdjustPosition } from "~/sharedHOC/adjustContainer/AdjustPosition";
import { getCoordStylesPositions } from "../helper/getAnnotationCoord";
import { adjustContentOptions } from "./ImageAnnotationsContent";
import * as styles from "./ImageAnnotationsEditor.less";
import { AnnotationTextArea } from "./ImageAnnotationsTextArea";

export type AnnotationEditorProps = React.ComponentProps<typeof AnnotationTextArea> & {
    isNew: boolean;
};

export const AnnotationEditor: React.FC<AnnotationEditorProps> = ({
    isNew,
    annotation,
    onSubmit,
    onChange,
    onCancel,
    withScroll,
}) => {
    const fakeDotRef = React.createRef<HTMLDivElement>();
    const tooltipRef = React.createRef<HTMLDivElement>();
    const adjustPositionRef = React.createRef<AdjustPosition>();
    const track = useTrackEvent();

    const { x, y } = annotation.geometry;
    const hasText = !!annotation.data?.text;

    React.useEffect(() => {
        adjustPositionRef.current.triggerAdjust();
    }, [x, y, hasText]);

    const onSave = () => {
        if (isNew) {
            track(messagesAuditEvents.imageAnnotationAdded);
        }

        onSubmit();
    };

    return (
        <div className={styles.editor} style={getCoordStylesPositions(annotation.geometry)}>
            <div className={styles.fake_dot} ref={fakeDotRef} /> {/* fake active dot: need to adjust from it */}
            <AdjustPosition
                ref={adjustPositionRef}
                baseElRef={fakeDotRef}
                childElRef={tooltipRef}
                adjustOptions={adjustContentOptions}
            >
                <div ref={tooltipRef} style={{ position: "absolute", left: "-9999px" }}>
                    <div className={classNames(styles.inner, styles.dark, styles.inner_tooltip)}>
                        <AnnotationTextArea
                            annotation={annotation}
                            onSubmit={onSave}
                            onChange={onChange}
                            onCancel={onCancel}
                            withScroll={withScroll}
                        />
                    </div>
                </div>
            </AdjustPosition>
        </div>
    );
};
